import React from 'react';
import loader from '../../assets/images/loader.svg';

interface CircularProgressProps {
  className?: string
}

export default function ({ className }: CircularProgressProps) {
  return (
    <div className={`loader ${className}`}>
      <img src={loader} alt="loader" />
    </div>
  );
}
